// START GENAI
vsr-tabs {
  display: block;
}

.vsr-tab-theme-light {
  --vsr-tab-bg: #f7f7f7;
  --vsr-tab-color: #1a1a1a;
  --vsr-tab-active-bg: #1a1a1a;
  --vsr-tab-active-color: #fff;
  --vsr-tab-border: #1a1a1a26;
  --vsr-tab-icon-color: #1a1a1a;
}

.vsr-tab-theme-dark {
  --vsr-tab-bg: #2c2c2c;
  --vsr-tab-color: #fff;
  --vsr-tab-active-bg: #fff;
  --vsr-tab-active-color: #1a1a1a;
  --vsr-tab-border: #ffffff33;
  --vsr-tab-icon-color: #fff;
}

.vsr-tab-bar-container {
  display: flex;
  justify-content: center; /* Default to center alignment */
  align-items: center;
  overflow: hidden;
  margin-bottom: 80px;

  &.tabs-exceed-width {
    justify-content: flex-start; /* Switch to left alignment when tabs exceed width */
  }

  /* Add media query for mobile */
  @media (max-width: 767px) {
    overflow-x: auto; /* Enable horizontal scrolling */
    -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */
    scrollbar-width: none; /* Hide scrollbar on Firefox */
    -ms-overflow-style: none; /* Hide scrollbar on IE/Edge */
    width: 100%; /* Take full width of container */

    /* Hide scrollbar on Webkit browsers */
    &::-webkit-scrollbar {
      display: none;
    }
  }
}

.vsr-tab-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 1000px;
  border: 1px solid var(--vsr-tab-border);
  padding: 12px;

  /* Animation styles for desktop/tablet */
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;

  /* Animation states */
  &.animating {
    will-change: width;
  }

  &.expanding {
    animation: expand-tabs 0.2s cubic-bezier(0.4, 0, 0.2, 1) forwards;
  }

  &.collapsing {
    animation: collapse-tabs 0.3s cubic-bezier(0.4, 0, 0.2, 1) forwards;
  }

  /* Original mobile styles that worked well */
  @media (max-width: 767px) {
    flex-wrap: nowrap; /* Prevent wrapping to ensure horizontal scrolling */
    width: max-content; /* Allow container to expand based on content */
    transition: none; /* Disable animations on mobile */
    max-width: none !important;
    overflow: visible; /* Ensure content is visible */

    &.expanding,
    &.collapsing {
      animation: none; /* Disable animations on mobile */
    }
  }
}

/* Keyframes for tab animations */
@keyframes expand-tabs {
  from {
    width: auto;
  }
  to {
    width: 100%;
  }
}

@keyframes collapse-tabs {
  to {
    width: var(--collapsed-width, auto);
  }
}

.vsr-tab {
  font-family: inherit;
  font-size: 0.75rem;
  font-weight: 400;
  border: none;
  background: none;
  color: var(--vsr-tab-color);
  border-radius: 56px;
  cursor: pointer;
  padding: 14px 16px;

  /* Animation transitions for desktop/tablet */
  transition:
    background 0.15s,
    color 0.15s,
    max-width 0.2s cubic-bezier(0.4, 0, 0.2, 1),
    padding 0.2s cubic-bezier(0.4, 0, 0.2, 1),
    margin 0.2s cubic-bezier(0.4, 0, 0.2, 1),
    opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap;

  &.hidden-tab {
    max-width: 0;
    padding: 0;
    margin: 0;
    opacity: 0;
    pointer-events: none;
  }

  &.fading-tab {
    opacity: 0.5;
    transition: opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }

  &.will-hide-tab {
    opacity: 0.5;
    transition: opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }

  /* Original mobile styles */
  @media (max-width: 767px) {
    white-space: nowrap;
    overflow: visible;
    min-width: max-content; /* Ensure tab takes full content width */
    flex-shrink: 0; /* Prevent shrinking */
    width: auto; /* Allow natural width */
    padding: 14px 16px; /* Ensure consistent padding */
  }
}

.vsr-tab.active {
  background: var(--vsr-tab-active-bg);
  color: var(--vsr-tab-active-color);
}

.vsr-tab-next-button {
  background: var(--vsr-tab-bg);
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  min-width: 40px;
  flex-shrink: 0;
}

.vsr-tab-next-button_icon {
  width: 1rem;
  height: 1rem;
}

.vsr-tab__plus-icon rect,
.vsr-tab__close-icon line {
  stroke: var(--vsr-tab-icon-color);
  fill: var(--vsr-tab-icon-color);
}

// END GENAI
